import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, ICheckboxProps } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const SaveCreditCard = (props: Partial<ICheckboxProps>) => {
	const { t } = useTranslation();
	const { register } = useFormContext();

	return (
		<Checkbox
			label={t('payment_form_save_credit_card_label')}
			{...props}
			{...register('saveCreditCard')}
		/>
	);
};
